import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  collabLoading: false,
  collabList: [],
  total: 0,
  size: 0,
  totalPages: 0,
  page: 0,
  loaderForButton: false,
  dropdownData: {},
  paginationData: { isPagination: false, type: null },
  searchData: { searchText: "", type: null },
  filterLoader: false,
  dropdownType: "",
  dropdownPage: 0,
  dropdownTotalPages: 0,
  dropdownSize: 0,
  dropdownIsFromLoadMore: false,
  dropdownLoading: false,
};
const collabSlice = createSlice({
  name: "collab",
  initialState,
  reducers: {
    setCollabLoading(state, action) {
      state.collabLoading = action?.payload;
    },
    setCollabList(state, action) {
      state.collabList = action?.payload?.pagination
        ? [...state.collabList, ...action?.payload?.collabList]
        : action?.payload?.collabList;
      state.total = action?.payload?.total;
      state.totalPages = action?.payload?.totalPages;
      state.page = action?.payload?.page;
      state.size = action?.payload?.size;
      state.loaderForButton = action?.payload?.loaderForButton;
      state.collabLoading = action?.payload?.collabLoading;
    },
    setDropdownData(state, action) {
      const { data, paginationData, searchData } = action.payload;

      if (paginationData?.isPagination) {
        state.dropdownData = {
          ...state.dropdownData, [paginationData?.type]: {
            ...state.dropdownData?.[paginationData?.type],
            options:
              [...state.dropdownData[paginationData?.type].options,
              ...data[paginationData?.type]?.options]
          }
        }
      }

      else if (searchData?.type) {
        state.dropdownData = {
          ...state.dropdownData, [searchData?.type]: data,
        }
      }

      else
        state.dropdownData = data;
      // state.dropdownData = paginationData?.isPagination ?
      //   {
      //     ...state.dropdownData, [paginationData?.type]: {
      //       ...state.dropdownData?.[paginationData?.type],
      //       options:
      //         [...state.dropdownData[paginationData?.type].options,
      //         ...data[paginationData?.type]?.options]
      //     }
      //   }
      //   :
      //   data
      state.paginationData = { isPagination: false, type: null }
    },

    setPaginationData(state, action) {
      state.paginationData = action?.payload
    },

    setSearchData(state, action) {
      state.searchData = action?.payload
    },

    clearDropdownData(state, action) {
      state.dropdownData = {};
    },

    setFilterLoader(state, action) {
      state.filterLoader = action?.payload;
    },

    setDropdownLoaderforButton(state, action) {
      state.dropdownIsFromLoadMore = action?.payload
    },

    setLoaderForButton(state, action) {
      state.loaderForButton = action?.payload;
    },
    clearCollab(action, state) {
      return initialState;
    },
  },
});

export const collabActions = collabSlice.actions;

export default collabSlice;
